import HttpRequest from './axios.js'
import config from './config.js'
const baseUrl =config.baseUrl.dev
//= process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

const axios = new HttpRequest(baseUrl)
export default axios